import { ADICIONAR_FILTRO_AGENDAMENTO_VIAGEM} from '../types'

export default function adicionarFiltroAgendamentoViagem (filtro) {
  return {
    type: ADICIONAR_FILTRO_AGENDAMENTO_VIAGEM,
    payload: filtro
  }
}
